import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthGmsAngularClientModule } from '@coin/shared/auth/feature';
import { AuthGmsClientConfig } from '@coin/shared/auth/util';
import { environment } from '@coin/shared/core/util-environments';
import { AppRoutingModule } from './app-routing.module';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      AuthGmsAngularClientModule.forRoot({
        ...environment.authentication,
        ...environment.storybookAuthentication
      } as AuthGmsClientConfig)
    ),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
};
